import React, { useState, useEffect } from "react";
import FooterImg from "./FooterImg";
import FooterCategoryItem from "../../components/FooterCategoryItem";
import { useSelector } from "react-redux";
import axios from "axios";
import { getContent } from "../../utils/main";

const Footer = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(true);
  const [images, setImages] = useState([]);
  const today = new Date();

  useEffect(() => {
    setImagesLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/multimedia/footer-images/`)
      .then((res) => {
        setImages(res.data);
      })
      .catch(() => {
        setImages([]);
      })
      .finally(() => {
        setImagesLoading(false);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/services/all/`)
      .then((res) => {
        setServices(res.data);
      })
      .then(() => {
        setIsServicesLoading(false);
      });
  }, []);

  return (
    <footer>
      <div className="container top">
        <div className="row">
          <div className="col-12 d-flex align-items-center justify-content-center">
            <img
              src={require("./../../assets/images/2d-logo.png")}
              alt="2d-logo"
            />
            <h4 className="mb-0 fw-bold">migration.gov.tm</h4>
          </div>
        </div>
      </div>
      <div className="six-images-wrapper container-fluid">
        {imagesLoading === true ? (
          "Loading..."
        ) : (
          <div className="row">
            {images.map((image) => (
              <FooterImg
                img={process.env.REACT_APP_API_URL + image.src}
                key={image.id}
              />
            ))}
          </div>
        )}
      </div>
      <div className="footer-menu container py-5">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 first-col">
            <div className="top">
              <img
                src={require("../../assets/images/logo.png")}
                alt="Footer logo"
              />
              <p>
                <span>{getContent(content, "STATE MIGRATION", lang)}</span>
                <span className="bottom">
                  {getContent(content, "SERVICE OF TURKMENISTAN", lang)}
                </span>
              </p>
            </div>
            <div className="about">
              <h6 className="footer-header">
                {getContent(content, "ABOUT US", lang)}
              </h6>
              <p>{getContent(content, "footer about", lang)}</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 second-col">
            <h6 className="footer-header">
              {getContent(content, "footer services", lang)}
            </h6>
            {isServicesLoading === true
              ? "Loading..."
              : services.map((service) =>
                  service.is_online === false ? (
                    <FooterCategoryItem
                      key={service.id}
                      category={
                        lang === "en"
                          ? service.name_en
                          : lang === "ru"
                          ? service.name_ru
                          : service.name_tm
                      }
                      to={service.url}
                    />
                  ) : (
                    ""
                  )
                )}
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 third-col">
            <h6 className="footer-header">
              {getContent(content, "footer online services", lang)}
            </h6>
            {isServicesLoading === true
              ? "Loading..."
              : services.map((service) =>
                  service.is_online === true ? (
                    <FooterCategoryItem
                      key={service.id}
                      category={
                        lang === "en"
                          ? service.name_en
                          : lang === "ru"
                          ? service.name_ru
                          : service.name_tm
                      }
                      to={service.url}
                    />
                  ) : (
                    ""
                  )
                )}
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 fourth-col">
            <h6 className="footer-header">
              {getContent(content, "STAY CONNECTED", lang)}
            </h6>
            <a
              href={getContent(content, "android-url", lang)}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={require("./../../assets/images/android.png")}
                alt="Android"
                className="android"
              />
            </a>
            <a
              href={getContent(content, "ios-url", lang)}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={require("./../../assets/images/ios.png")}
                alt="IOS"
                className="ios"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="bottom-footer">
        <p>TDMG © {today.getFullYear()} All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
